jQuery(($) => {
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Browser - Keydown Focus Class
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

  $("body").on("keydown", function () {
    if (!$(".keyboard-in-use")[0]) {
      $(this).addClass("keyboard-in-use");
    }
  });

  $("body").on("mousedown", function () {
    if ($(".keyboard-in-use")[0]) {
      $(this).removeClass("keyboard-in-use");
    }
  });

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Search - Header
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡ 
  const $searchInput = $(".o-header__search-form");
  let outsideSearchClickHandler;
  let escapeSearchKeyHandler;

  const closeSearch = () => {
    $searchInput.removeClass("o-header__search-form--open");

    if (outsideSearchClickHandler) {
      $(document).off("click", outsideSearchClickHandler);
      outsideSearchClickHandler = undefined;
    }

    if (escapeSearchKeyHandler) {
      $(document).off("keydown", escapeSearchKeyHandler);
      escapeSearchKeyHandler = undefined;
    }
  };

  const openSearch = () => {
    $searchInput.addClass("o-header__search-form--open");

    setTimeout(() => {
      $("#search-input").focus();
    }, 200);

    outsideSearchClickHandler = function (event) {
      const clickedInsideSearch = $(event.target).closest(
        ".o-header__search-form, #search-toggle",
      ).length;

      if (!clickedInsideSearch) {
        closeSearch();
      }
    };

    // Delay binding so the opening click does not immediately close the search.
    setTimeout(() => {
      $(document).on("click", outsideSearchClickHandler);
    }, 0);

    escapeSearchKeyHandler = function (event) {
      if (event.key === "Escape" || event.keyCode === 27) {
        closeSearch();
      }
    };

    $(document).on("keydown", escapeSearchKeyHandler);
  };

  // instead of using toggle, open and close so that we can focus it on open
  $("#search-toggle").on("click", function (event) {
    event.preventDefault();
    if ($searchInput.hasClass("o-header__search-form--open")) {
      closeSearch();
    } else {
      openSearch();
    }
  });

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ Resources - Category Filter
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  const $resourceCategoryFilter = $("#resource-category-filter");

  $resourceCategoryFilter.on("change", function () {
    const selectedCategory = $(this).val();
    const url = new URL(window.location.href);

    if (selectedCategory) {
      url.searchParams.set("category", selectedCategory);
    } else {
      url.searchParams.delete("category");
    }

    // Reset pagination when changing category filters.
    url.searchParams.delete("paged");

    window.location.href = url.toString();
  });

  const bindArchiveSearchAndFilter = (searchInputSelector, filterSelector) => {
    const $filter = $(filterSelector);
    const $searchInput = $(searchInputSelector);

    if (!$filter.length || !$searchInput.length) {
      return;
    }

    const $searchForm = $searchInput.closest("form");
    if (!$searchForm.length) {
      return;
    }

    $searchForm.on("submit", function () {
      const selectedCategory = $filter.val();
      let $hiddenCategoryInput = $(this).find('input[name="category"]');

      if (selectedCategory) {
        if (!$hiddenCategoryInput.length) {
          $hiddenCategoryInput = $('<input type="hidden" name="category" />').appendTo(this);
        }

        $hiddenCategoryInput.val(selectedCategory);
      } else {
        $hiddenCategoryInput.remove();
      }
    });
  };

  bindArchiveSearchAndFilter("#resource-search-input", "#resource-category-filter");

  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  // ✅ FAQs - Category Filter
  //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  const $faqCategoryFilter = $("#faq-category-filter");

  $faqCategoryFilter.on("change", function () {
    const selectedCategory = $(this).val();
    const url = new URL(window.location.href);

    if (selectedCategory) {
      url.searchParams.set("category", selectedCategory);
    } else {
      url.searchParams.delete("category");
    }

    window.location.href = url.toString();
  });

  bindArchiveSearchAndFilter("#faq-search-input", "#faq-category-filter");

});
